module.exports = __webpack_public_path__ + "img/9788901105949.0d8c8a52.jpg";